<div class="container-fluid login-page-wrapper">
  <div class="gradient-bg-repeat"></div>
  <div class="container gradient-card">
    <button class="nav-link back-btn" (click)="goBack()">Back</button>
    <img
      src="assets/img/logo/down_logo.png"
      class="bottom-watermark"
      alt="Watermark Logo"
    />
    <div class="row">
      <div class="col-12 col-md-7">
        <img src="assets/img/logo/edc_logo.png" class="img-fluid" alt="Logo" />
        <p class="welcome-text left">Where Science Meets Simplicity.</p>
      </div>
      <div class="col-12 col-md-5">
        <div class="card-body">
          <!-- Toggle Buttons -->
          <div class="toggle-buttons text-center mb-4">
            <button
              class="btn"
              [class.active]="!isRegister"
              (click)="toggleLogin()"
            >
              Login
            </button>
            <button
              class="btn"
              [class.active]="isRegister"
              (click)="toggleRegister()"
            >
              Register
            </button>
          </div>
          <ng-container *ngIf="!isRegister">
            <ng-container *ngIf="!showOtpForm; else OTPForm"
              ><h3 class="form-title">Login with Email</h3></ng-container
            >
            <ng-template #OTPForm
              ><h3 class="form-title">Reset Your Password</h3></ng-template
            >
            <form [formGroup]="form" (ngSubmit)="submitForm()">
              <div *ngIf="!showOtpForm">
                <div class="mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    name="email"
                    formControlName="Email"
                    placeholder="Enter your email"
                    (keydown)="onKeyDown($event)"
                    [class.error]="loginSubmitted && form.get('Email')?.invalid"
                  />
                  <div *ngIf="loginSubmitted && form.get('Email')?.invalid">
                    <div
                      *ngIf="form.get('Email').hasError('required')"
                      class="error-message"
                    >
                      Email is required.
                    </div>
                    <div
                      *ngIf="
                        form.get('Email').hasError('email') &&
                        !form.get('Email').hasError('required')
                      "
                      class="error-message"
                    >
                      Enter a valid email address.
                    </div>
                  </div>
                </div>
                <div class="mb-3 form-password-toggle">
                  <div class="input-group input-group-merge">
                    <input
                      [type]="showLoginPassword ? 'text' : 'password'"
                      class="form-control"
                      id="password"
                      name="password"
                      formControlName="Password"
                      placeholder="Enter your password"
                      (keydown)="onKeyDown($event)"
                      [class.error]="
                        loginSubmitted && form.get('Password')?.invalid
                      "
                    />
                    <span
                      class="input-group-text cursor-pointer"
                      (click)="toggleLoginPasswordVisibility()"
                    >
                      <i
                        class="bx"
                        [ngClass]="showLoginPassword ? 'bx-show' : 'bx-hide'"
                      ></i>
                    </span>
                  </div>
                  <div *ngIf="loginSubmitted && form.get('Password')?.invalid">
                    <div
                      *ngIf="form.get('Password').hasError('required')"
                      class="error-message"
                    >
                      Password is required.
                    </div>
                  </div>
                </div>
                <button type="submit" class="custom-otp-btn d-grid w-100">
                  Login
                </button>
                <div class="forgot">
                  <a
                    style="cursor: pointer"
                    (click)="showOtpForm = !showOtpForm"
                  >
                    Forgot Password</a
                  >
                </div>
              </div>
              <div *ngIf="showOtpForm && !verifyOtp">
                <div class="mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    formControlName="Email"
                    placeholder="Enter your Email"
                    autofocus
                  />
                </div>
                <a
                  [ngClass]="{
                    'error-message':
                      otpStatus && otpStatus.toLowerCase().includes('error')
                  }"
                  >{{ otpStatus }}</a
                >
                <button
                  type="button"
                  class="custom-otp-btn d-grid w-100"
                  [disabled]="!form.get('OTP')?.valid"
                  (click)="onRequestOtp()"
                >
                  Continue
                </button>
              </div>
              <div *ngIf="showOtpForm && verifyOtp">
                <div class="mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="OTP"
                    formControlName="OTP"
                    placeholder="Enter Verification code"
                    autofocus
                  />
                </div>
                <div class="mb-3 form-password-toggle">
                  <div class="input-group input-group-merge">
                    <input
                      [type]="showResetPassword ? 'text' : 'password'"
                      class="form-control"
                      id="Newpassword"
                      formControlName="NewPassword"
                      placeholder="Enter Your new Password"
                      autofocus
                      [class.error]="form.get('NewPassword')?.invalid && form.get('NewPassword')?.touched"
                    />
                    <span
                      class="input-group-text cursor-pointer"
                      (click)="toggleResetPasswordVisibility()"
                    >
                      <i
                        class="bx"
                        [ngClass]="showResetPassword ? 'bx-show' : 'bx-hide'"
                      ></i>
                    </span>
                  </div>
                  <div
                    *ngIf="form.get('NewPassword')?.invalid && form.get('NewPassword')?.touched"
                  >
                    <div
                      *ngIf="form.get('NewPassword')?.hasError('required')"
                      class="error-message"
                    >
                      Password is required.
                    </div>
                    <div
                      *ngIf="form.get('NewPassword')?.hasError('minLength')"
                      class="error-message"
                    >
                      Password must be at least 8 characters long.
                    </div>
                    <div
                      *ngIf="form.get('NewPassword')?.hasError('noCapital')"
                      class="error-message"
                    >
                      Password must contain at least one capital letter.
                    </div>
                    <div
                      *ngIf="form.get('NewPassword')?.hasError('noSmall')"
                      class="error-message"
                    >
                      Password must contain at least one small letter.
                    </div>
                    <div
                      *ngIf="form.get('NewPassword')?.hasError('noNumber')"
                      class="error-message"
                    >
                      Password must contain at least one number.
                    </div>
                    <div
                      *ngIf="form.get('NewPassword')?.hasError('noSpecial')"
                      class="error-message"
                    >
                      Password must contain at least one special character.
                    </div>
                  </div>
                </div>
                <a
                  [ngClass]="{
                    'error-message':
                      otpStatus && otpStatus.toLowerCase().includes('error')
                  }"
                  >{{ otpStatus }}</a
                >
                <button
                  type="button"
                  class="custom-otp-btn d-grid w-100"
                  [disabled]="!form.get('OTP')?.valid"
                  (click)="onValidateOtp()"
                >
                  Change Password
                </button>
                <br />

                <button
                  *ngIf="canResendOtp"
                  type="button"
                  class="custom-otp-btn d-grid w-100"
                  (click)="onResendOtp()"
                >
                  Resend OTP
                </button>
              </div>
            </form>
          </ng-container>

          <!-- REGISTER FORM -->
          <ng-container *ngIf="isRegister">
            <form [formGroup]="form" class="mb-2" (ngSubmit)="onSubmit()">
              <div class="mb-3">
                <h3 class="form-title mb-4">Sign Up</h3>
                <input
                  type="text"
                  class="form-control"
                  formControlName="FirstName"
                  placeholder="Enter your first name"
                  autofocus
                  (keydown)="onKeyDown($event)"
                  [class.error]="
                    registerSubmitted && form.get('FirstName')?.invalid
                  "
                />
                <div
                  *ngIf="registerSubmitted && form.get('FirstName')?.invalid"
                >
                  <div
                    *ngIf="form.get('FirstName')?.hasError('required')"
                    class="error-message"
                  >
                    First name is required.
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  formControlName="LastName"
                  placeholder="Enter your last name"
                  autofocus
                  (keydown)="onKeyDown($event)"
                  [class.error]="
                    registerSubmitted && form.get('LastName')?.invalid
                  "
                />
                <div
                  *ngIf="registerSubmitted && form.get('LastName')?.invalid"
                >
                  <div
                    *ngIf="form.get('LastName')?.hasError('required')"
                    class="error-message"
                  >
                    Last name is required.
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter your email"
                  formControlName="Email"
                  (keydown)="onKeyDown($event)"
                  [class.error]="
                    registerSubmitted && form.get('Email')?.invalid
                  "
                />
                <div
                  *ngIf="registerSubmitted && form.get('Email')?.invalid"
                >
                  <div
                    *ngIf="form.get('Email')?.hasError('required')"
                    class="error-message"
                  >
                    Email is required.
                  </div>
                  <div
                    *ngIf="
                      form.get('Email')?.hasError('email') &&
                      !form.get('Email')?.hasError('required')
                    "
                    class="error-message"
                  >
                    Enter a valid email address.
                  </div>
                </div>
              </div>
              <div class="mb-3 form-password-toggle">
                <div class="input-group input-group-merge">
                  <input
                    [type]="showPassword ? 'text' : 'password'"
                    class="form-control"
                    formControlName="Password"
                    placeholder="Enter your password"
                    aria-describedby="password"
                    (keydown)="onKeyDown($event)"
                    [class.error]="
                      registerSubmitted && form.get('Password')?.invalid
                    "
                  />

                  <span
                    class="input-group-text cursor-pointer"
                    (click)="togglePasswordVisibility()"
                  >
                    <i
                      class="bx"
                      [ngClass]="showPassword ? 'bx-show' : 'bx-hide'"
                    ></i>
                  </span>
                </div>
                <div
                  *ngIf="registerSubmitted && form.get('Password')?.invalid"
                >
                  <div
                    *ngIf="form.get('Password')?.hasError('required')"
                    class="error-message"
                  >
                    Password is required.
                  </div>
                  <div
                    *ngIf="form.get('Password')?.hasError('minLength')"
                    class="error-message"
                  >
                    Password must be at least 8 characters long.
                  </div>
                  <div
                    *ngIf="form.get('Password')?.hasError('noCapital')"
                    class="error-message"
                  >
                    Password must contain at least one capital letter.
                  </div>
                  <div
                    *ngIf="form.get('Password')?.hasError('noSmall')"
                    class="error-message"
                  >
                    Password must contain at least one small letter.
                  </div>
                  <div
                    *ngIf="form.get('Password')?.hasError('noNumber')"
                    class="error-message"
                  >
                    Password must contain at least one number.
                  </div>
                  <div
                    *ngIf="form.get('Password')?.hasError('noSpecial')"
                    class="error-message"
                  >
                    Password must contain at least one special character.
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    formControlName="Terms"
                  />
                  <label class="form-check-label" for="terms-conditions"
                    >I agree to
                    <a href="javascript:void(0);"
                      >privacy policy & terms</a
                    ></label
                  >
                  <div *ngIf="registerSubmitted && form.get('Terms')?.invalid">
                    <div class="error-message">You must agree to the terms.</div>
                  </div>
                </div>
              </div>
              <button type="submit" class="custom-otp-btn d-grid w-100">
                Sign up
              </button>
            </form>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
